import { render, staticRenderFns } from "./PropertyTicketList.vue?vue&type=template&id=59d812c3&scoped=true"
import script from "./PropertyTicketList.vue?vue&type=script&lang=js"
export * from "./PropertyTicketList.vue?vue&type=script&lang=js"
import style0 from "./PropertyTicketList.vue?vue&type=style&index=0&id=59d812c3&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d812c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAlert,VCardTitle,VContainer,VDataTable,VProgressLinear})
